// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskPercents {
  // public iconMask(){
  //   return 'svg-icon-currency';
  // }

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    if (!value || typeof value !== 'string') {
      return { newValue: '0', newCursorPosition: 0 };
    }
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    let shiftedValue = newValue.replace(/^[0]+/, '');

    let correctPosition = 0;

    if (shiftedValue.length === 0) {
      return { newValue: '', newCursorPosition: 0 };
    } else if (shiftedValue.length === 1) {
      shiftedValue = '00' + shiftedValue;
      correctPosition += 3;
    } else if (shiftedValue.length === 2) {
      shiftedValue = '0' + shiftedValue;
      correctPosition++;
    }

    const part1 = shiftedValue.substring(0, shiftedValue.length - 2);
    const part2 = shiftedValue.substring(shiftedValue.length - 2, shiftedValue.length);

    if (newCursorPosition > shiftedValue.length - 2) {
      correctPosition++;
    }

    const newFloatValue = part1 + '.' + part2;
    const positionCorrected = newCursorPosition + correctPosition;

    return { newValue: newFloatValue, newCursorPosition: positionCorrected };
  }

  public setMask(value, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      if (!value || typeof value !== 'string') {
        return { formatedValue: '', formatedCursorPosition: 0 };
      }

      const distanceToFinal = value.length - cursorPosition;
      let correction = 0;

      const newValue = value.replace(/(^[\d]+)[.](\d{2})/g, this.replacePercent);

      let formatedCursorPosition = newValue.length;

      if (distanceToFinal > 2) {
        correction += 2;
        const distanceInteggerPart = distanceToFinal - 2;
        const triadsDigits = Math.floor(distanceInteggerPart / 3);
        correction += triadsDigits * 3;
      }

      formatedCursorPosition = newValue.length - (distanceToFinal + correction);

      return { formatedValue: newValue, formatedCursorPosition };
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  private replacePercent(match: string, mainNumber: string, decimalNumber: string): string {
    let decimal = mainNumber
      .split('')
      .reverse()
      .join('')
      .replace(/(\d{3})/g, '$1 . ')
      .split('')
      .reverse()
      .join('');
    decimal = decimal.replace(/^([ ][.][ ])/, '');
    return `${decimal},${decimalNumber}%`;
  }
}
